import React from "react";
import "./ServiceSection.css";
import img1 from "../../../assets/ColumbusPage/Columbus_Ohio_Roofing_Contractor_Near_You_ultimatesroofing.jpg";
import img2 from "../../../assets/ColumbusPage/Hero Section/Best_Roofing_Contractors_Columbus_Ohio_UltimatesRoofing.png";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Free from "./Free";
import Badge from "./Badge";

const sectionVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: [0.22, 1, 0.36, 1],
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

const ServiceSection = () => {
  return (
    <section className="cs-section overflow-hidden py-lg-4 py-3 px-2" style={{backgroundColor: '#f8f9fa'}}>
      <div className="container">
        <div className="row  g-lg-2 g-md-5 g-5">
          {/* Left Side: Content */}
          <motion.div
            className="col-lg-6"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
          >
            <div className="base-section-header">
              
              {/* --- Badge Fixed (Top Aligned) --- */}
              <div className="cs-badge d-flex justify-content-lg-start justify-content-center">
              <Badge text="Serving Columbus"></Badge>
              </div>



              <h2
                className="cs-title text-lg-start text-center w-100 font-hauora service-header"
                style={{ color: "#050000" }}
              >
                Columbus Roofing Contractor Near You
              </h2>

              <p
                className="cs-desc font-hauora service-p text-lg-start text-center"
                style={{ lineHeight: "1.7" }}
              >
                When it comes to protecting your property, choosing the right residential roofing contractor in Columbus
                makes all the difference. At{" "}
                <Link to="/" className="text-decoration-none color">
                  Utimatesroofing
                </Link>{" "}
                we bring decades of hands-on experience, industry expertise,
                and a commitment to excellence to every project.{" "}
              </p>

              <p
                className="cs-desc font-hauora service-p text-lg-start text-center"
                style={{ lineHeight: "1.7" }}
              >
                From minor residential roofing repairs to complete roof replacements, our roofer delivers durable, long-lasting results
                tailored to Ohio’s changing weather conditions. Whether you're dealing with storm damage, ageing shingles, or planning
                a new installation, we’re here to help—fast, affordable, and professional.
              </p>
            </div>
<div className="cs-content">
 <Free />
</div>
           
          </motion.div>

          {/* Right Side: Images */}
          <motion.div
            className="col-lg-6 position-relative ps-lg-5"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="image-stack-container position-relative">
              <div className="main-image-wrapper rounded-5 shadow-aesthetic overflow-hidden">
                <img
                  src={img2}
                  alt="Commercial Roof"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </div>

              <motion.div
                className="secondary-image-wrapper position-absolute rounded-5 shadow-aesthetic-secondary border border-5 border-white overflow-hidden d-none d-md-block"
                style={{
                  width: "280px",
                  height: "220px",
                  zIndex: 10,
                  bottom: "-5%",
                  right: "-8%",
                }}
              >
                <img
                  src={img1}
                  alt="Roofing Detail"
                  className="img-fluid w-100 h-100 object-fit-cover"
                />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;